import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY;
const aesKey = process.env.REACT_APP_AESKEY;
const aesIVKey = process.env.REACT_APP_AESIVKEY;

const aesKeySSO = process.env.REACT_APP_AESKEY_SSO;
const aesIVKeySSO = process.env.REACT_APP_AESIVKEY_SSO;

const Key = CryptoJS.enc.Base64.parse(aesKey);
const IV = CryptoJS.enc.Base64.parse(aesIVKey);

const KeySSO = CryptoJS.enc.Base64.parse(aesKeySSO);
const IVSSO = CryptoJS.enc.Base64.parse(aesIVKeySSO);

function encryptSotrageData(data) {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey);
  return encryptedData.toString();
}

function encryptSotrageDataSSO(data) {
  data = JSON.stringify(data);
  let encryptedData = CryptoJS.AES.encrypt(data.toString(), aesKeySSO).toString();
  encryptedData = encodeURIComponent(encryptedData);
  encryptedData = encryptedData.replaceAll('/', 's2e0s21');
  return encryptedData;
}

function decryptStorageData(encryptedData) {

  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

function decryptStorageDataSSO(res, isObject) {
  res = res.replaceAll('s2e0s21', '/');
  res = decodeURIComponent(res);
  // res = res.replaceAll(' ', '+');
  const data = CryptoJS.AES.decrypt(res, aesKeySSO).toString(CryptoJS.enc.Utf8);
  if (isObject === true) {
    return { ...JSON.parse(data) };
  }
  else {
    return data.toString();
  }
}

const encryptAES = (data) => {
  const input = typeof data === 'object' ? JSON.stringify(data) : data.toString();
  const encrypted = CryptoJS.AES.encrypt(input, Key, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

const encryptAESSSO = (data) => {
  // const input = typeof data === 'object' ? JSON.stringify(data) : data.toString();
  // const encrypted = CryptoJS.AES.encrypt(input, KeySSO, {
  //   iv: IVSSO,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // });
  // return encrypted.toString();
  data = JSON.stringify(data);
  var encprtArray = CryptoJS.enc.Utf8.parse(data);
  var decryptedText = CryptoJS.AES.encrypt(encprtArray, KeySSO,
    {
      iv: IVSSO,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  return decryptedText.ciphertext.toString(CryptoJS.enc.based64);
};

const decryptAESSSO = (res) => {
  var response = { ...res };
  if (response.isEnType !== undefined && response.isEnType !== "undefined" && response.isEnType !== "null" && response.isEnType !== null) {
    if (response.isEnType === true) {
      var appkey = KeySSO;
      var appkeyvalue = IVSSO;
      var cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(response.responseData)
      });
      var decryptedText = CryptoJS.AES.decrypt(cipherParams, appkey, {
        iv: appkeyvalue,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      var data = decryptedText.toString(CryptoJS.enc.Utf8)
      if (res.responseType === 0) {
        return { ...JSON.parse(data) };
      }
      else {
        return data.toString();
      }
    }
    else {
      return { ...JSON.parse(res.typeData) };
    }
  }
  else {
    return response;
  }
};

const decryptAES = (encryptedData) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, Key, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  try {
    // Attempt to parse decrypted data as JSON
    const parsedData = JSON.parse(decryptedText);
    return parsedData;
  } catch (error) {
    // If parsing as JSON fails, return the decrypted data as is
    return decryptedText;
  }
};

const encryptUrlData = (data) => {
  const encrypted = encryptAES(data).replaceAll('/', 's2e0s21').replaceAll('+', 's2e0s22');
  return encrypted;
}

const decryptUrlData = (data) => {
  data = data.replaceAll('s2e0s21', '/').replaceAll('s2e0s22', '+');
  const decrypted = decryptAES(data);
  return decrypted;
}

export { encryptSotrageData, decryptStorageData, encryptAES, decryptAES, encryptUrlData, decryptUrlData, encryptAESSSO, decryptAESSSO, encryptSotrageDataSSO , decryptStorageDataSSO };
